export default {
    '语言': '印地语',
}

